import jsonData from './genre.json';
import { toCamelCaseKeys } from '@/js/lib/helper/localize-keys';

interface Genre {
  genreId: number;
  slug: string;
  name: string;
}

export default toCamelCaseKeys(jsonData) as Genre[];
